export default "__VITE_ASSET__KJsoNxFO__"